export const buildCountRequest = (filter: string) => {
  return `filter=${filter}`;
};

export const buildDataSourceRequest = (
  pageSize: number,
  skip: number,
  sort: string,
  filter: string
) => {
  return `pageSize=${pageSize}&skip=${skip}&sort=${sort}&filter=${filter}`;
};

export const getApiUrl = (endpoint?: string) => {
  if (endpoint) {
    return new URL(
      `${import.meta.env.VITE_APP_API_URL ?? window['EnvironmentConfigs']['apiUrl']}${endpoint}`
    );
  } else {
    return new URL(
      `${import.meta.env.VITE_APP_API_URL ?? window['EnvironmentConfigs']['apiUrl']}`
    );
  }
};

export default buildDataSourceRequest;
